import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxsModule } from "@ngxs/store";
import { QuotesState } from "./quotes.state";

@NgModule({
    imports: [CommonModule, NgxsModule.forFeature([QuotesState])],
    declarations: []
})
export class QuotesStoreModule { }
